export const hidden = 0;
export const fullyVisible = 1;



// WEBPACK FOOTER //
// ./../src/utilities/Opacity.js